import { useQuery } from '@apollo/client';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { ChangeEvent, FC, useState } from 'react';
import Input from '../../../components/form/input';
import Loader from '../../../components/loader';
import { PATIENTS_FILTER } from '../../../graphql/query/patients';
import { GraphQLResponseTitan, SearchPatientsFuzzy } from '../../../types';
import Patient from './patient/patient';
import styles from './styles.module.css';

const PatientsListView: FC = () => {
  const [filter, setFilter] = useState('');

  const {
    loading,
    data: res,
    refetch: search,
  } = useQuery<GraphQLResponseTitan<'searchPatientsFuzzy', SearchPatientsFuzzy>>(PATIENTS_FILTER, {
    fetchPolicy: 'network-only',
  });

  const data = res?.searchPatientsFuzzy.data;

  const handleUpdateFilter = (e: ChangeEvent<HTMLInputElement>) => {
    const filter = e.target.value;
    setFilter(filter);
    if (filter === '' || filter.length >= 3) {
      search({
        fuzzySearch: filter,
      });
    }
  };

  return (
    <div className={styles.wrapper}>
      {/* header area */}
      <div className={styles.header}>
        <div className={styles.inputWrapper}>
          <Input.Component
            placeholder="Search for Limbic Code or patient's name or email address..."
            value={filter}
            onChange={handleUpdateFilter}
            style={{
              width: '100%',
              border: '0',
              backgroundColor: 'transparent',
              padding: '1rem 2rem 1rem 2.5rem',
            }}
            controlProps={{
              style: {
                width: '100%',
              },
            }}
            iconLeft={<FontAwesomeIcon icon={faSearch as IconProp} className={styles.inputIcon} />}
          />
        </div>
      </div>

      <div className={styles.tableWrapper}>
        {/* header row */}
        <div className={clsx(styles.tableHeader, 'is-hidden-mobile')}>
          <div className={styles.rowLeft}>
            <div className={clsx(styles.rowItem, styles.rowItemCollapse)}>
              {/* invitation row */}
            </div>
            <div className={styles.rowItem}>Limbic Code</div>
            <div className={styles.rowItem}>Date of Birth</div>
          </div>
          <div className={styles.rowRight}>
            <div className={styles.rowItem}>IAPT</div>
            <div className={styles.rowItem}>Patient Status</div>
          </div>
        </div>

        {/* table */}
        <div className={styles.table}>
          {loading && (
            <div className={styles.loader}>
              <Loader loading={loading} />
            </div>
          )}

          {!data && !loading && (
            <div className={styles.loader}>
              <span>Try searching using the bar above.</span>
            </div>
          )}

          {data && !data.length && (
            <div className={styles.loader}>
              <span>No results found{filter.length > 0 && ` matching "${filter}"`}.</span>
            </div>
          )}

          {data &&
            data.length > 0 &&
            data.map(patient => (
              <Patient
                key={patient.id}
                patient={patient}
                onUpdate={() => search({ fuzzySearch: filter })}
              />
            ))}

          {data && data.length > 0 && (
            <div className={styles.loader} style={{ paddingTop: '2rem' }}>
              <span className={styles.textMuted}>
                {`${data.length} result${data.length > 1 ? 's' : ''}`}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientsListView;
